var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLatestRun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.125 11V2c0-.188.164-.375.375-.375h3.75V3.5c0 .422.328.75.75.75h1.875V11c0 .21-.188.375-.375.375h-6A.37.37 0 0 1 1.125 11zM1.5.5C.656.5 0 1.18 0 2v9c0 .844.656 1.5 1.5 1.5h6c.82 0 1.5-.656 1.5-1.5V4.133c0-.399-.164-.774-.445-1.055L6.422.945A1.491 1.491 0 0 0 5.367.5H1.5zm.75 2.25a.385.385 0 0 0-.375.375c0 .21.164.375.375.375h1.875a.385.385 0 0 0 .375-.375.403.403 0 0 0-.375-.375H2.25zm0 1.5a.385.385 0 0 0-.375.375c0 .21.164.375.375.375h1.875a.385.385 0 0 0 .375-.375.403.403 0 0 0-.375-.375H2.25zm1.266 5.203.234-.773.375 1.312c.047.14.188.258.328.258a.38.38 0 0 0 .375-.188l.234-.515c.024-.024.047-.047.094-.047.024 0 .047.023.07.047l.235.515c.07.118.187.188.351.188h.938a.385.385 0 0 0 .375-.375.403.403 0 0 0-.375-.375h-.727l-.14-.281a.827.827 0 0 0-.727-.469.84.84 0 0 0-.562.21l-.258-.89a.626.626 0 0 0-.586-.445.626.626 0 0 0-.61.469l-.35 1.148a.352.352 0 0 1-.353.258H2.25a.385.385 0 0 0-.375.375c0 .21.164.375.375.375h.188c.492 0 .937-.305 1.078-.797z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatestRun);
export default __webpack_public_path__ + "static/media/latest-run.de81a487ea2153ce9ffecae994b709f2.svg";
export { ForwardRef as ReactComponent };